import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { EnvironmentService } from 'shared/services';
import { WorkforceService } from 'api/services/workforce/workforce-service';
import { WorkflowService } from 'api/services/workflow/workflow-service';
import { ShiftService } from './shift/shift-service';
import { DepartmentService } from './department/department-service';
import { WorkTemplateService } from './work-template/work-template-service';
import { CompanyService } from './company/company-service';
import { PaymentsService } from './finance/payments.service';
import { DashboardService } from './dashboard/dashboard-service';
import { ProjectService } from './project/project-service';
import { ShiftClaimService } from './shift-claim/shift-claim-service';
import { FlexPoolService } from './flexpools/flex-pool-service';
import { AvailabilityService } from './availability/availability-service';
import { WorkersService } from './workers/workers-service';

const ogpEndpoint = EnvironmentService.getVariable('BACKEND_OGP_URI');
const hqEndpoint = EnvironmentService.getVariable('BACKEND_HQ_URI');

const ogpApiService = new OgpApiService({ endpoint: ogpEndpoint });
const hqApiService = new HqApiService({ endpoint: hqEndpoint });

export const sharedShiftService = new ShiftService(ogpApiService, hqApiService);
export const sharedShiftClaimService = new ShiftClaimService(ogpApiService, hqApiService);
export const sharedDepartmentService = new DepartmentService(ogpApiService, hqApiService);
export const sharedWorkTemplateService = new WorkTemplateService(ogpApiService, hqApiService);
export const sharedCompanyService = new CompanyService(ogpApiService, hqApiService);
export const sharedPaymentService = new PaymentsService(hqApiService);
export const sharedWorkflowService = new WorkflowService(ogpApiService);
export const dashboardService = new DashboardService(ogpApiService);
export const sharedProjectService = new ProjectService(ogpApiService, hqApiService);
export const sharedFlexPoolService = new FlexPoolService(ogpApiService, hqApiService);
export const sharedWorkforceService = new WorkforceService(ogpApiService);
export const availabilityService = new AvailabilityService(ogpApiService, hqApiService);
export const sharedWorkersService = new WorkersService(hqApiService, ogpApiService);
